import { render, staticRenderFns } from "./DesktopSignIn.vue?vue&type=template&id=96e6d79e&scoped=true&"
import script from "./DesktopSignIn.vue?vue&type=script&lang=ts&"
export * from "./DesktopSignIn.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopSignIn.vue?vue&type=style&index=0&id=96e6d79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e6d79e",
  null
  
)

export default component.exports